module.exports = __webpack_public_path__ + "img/pencil.4d08867e.svg";